<template>
    <div v-if="loading" class="section text-center pt-3">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>

    <template v-else-if="program.id">
        <ReliefFamilyForm
            v-if="program.include_relief_fields !== false"
            ref="reliefForm"
            :unit_id="$route.params.id"
            :page-title="program.title || 'സ്നേഹ സ്പർശം അപേക്ഷ'"
            :defer-submit="true"
            :hide-relief-types="true"
            :sneha-sparsham-check="true"
            :program-id="program.id"
            @validated-submit="onReliefValidated"
        />

        <div class="section pt-0 mt-1 pb-2" v-if="formFields.length">
            <div class="card">
                <div class="card-body">
                    <h5 class="mal-text text-primary mb-3">പദ്ധതി അപേക്ഷ വിവരങ്ങൾ</h5>
                    <div class="form-group basic" v-for="(field, index) in formFields" :key="field.key">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary">
                                {{ index + 1 }}. {{ field.label_ml }}
                                <span v-if="field.required || effectiveGroupKey(field)" class="text-danger">*</span>
                            </label>
                            <input v-if="field.type === 'text'" type="text" class="form-control"
                                v-model="extraData[field.key]" />
                            <textarea v-else-if="field.type === 'textarea'" class="form-control" rows="3"
                                v-model="extraData[field.key]"></textarea>
                            <select
                                v-else-if="field.type === 'select'"
                                class="form-control custom-select"
                                :class="{ 'sneha-select-placeholder': !extraData[field.key] }"
                                v-model="extraData[field.key]"
                            >
                                <option value="" disabled hidden>തിരഞ്ഞെടുക്കുക</option>
                                <option v-for="opt in field.options || []" :key="opt" :value="opt">{{ opt }}</option>
                            </select>
                            <div v-else-if="field.type === 'yes_no'" class="sneha-option-group">
                                <label
                                    v-for="opt in yesNoOptions"
                                    :key="field.key + '_' + opt.value"
                                    class="sneha-option-tile"
                                    :class="{ selected: extraData[field.key] === opt.value }"
                                >
                                    <input
                                        type="radio"
                                        class="sneha-option-input"
                                        :name="'extra_' + field.key"
                                        :value="opt.value"
                                        v-model="extraData[field.key]"
                                    />
                                    <span class="sneha-option-label">{{ opt.label }}</span>
                                </label>
                            </div>
                            <div v-else-if="field.type === 'checkbox'" class="sneha-option-group sneha-option-group--stack">
                                <label
                                    v-for="opt in field.options || []"
                                    :key="field.key + '_' + opt"
                                    class="sneha-option-tile sneha-option-tile--check"
                                    :class="{ selected: isCheckboxChecked(field.key, opt) }"
                                >
                                    <input
                                        type="checkbox"
                                        class="sneha-option-input"
                                        :value="opt"
                                        :checked="isCheckboxChecked(field.key, opt)"
                                        @change="toggleCheckbox(field.key, opt, $event)"
                                    />
                                    <span class="sneha-option-label">{{ opt }}</span>
                                </label>
                            </div>
                            <input
                                v-if="field.type === 'select' && (field.extra_field_options || []).includes(extraData[field.key])"
                                type="text"
                                class="form-control mt-2"
                                v-model="extraData[field.key + '__extra']"
                                :placeholder="field.extra_field_label || ''"
                            />
                        </div>
                    </div>

                    <button type="button" class="btn btn-primary btn-block btn-lg" :disabled="submitting"
                        @click="submitApplication">
                        <span v-show="submitting" class="spinner-border spinner-border-sm"></span>
                        <span>അപേക്ഷ സമർപ്പിക്കുക</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="section pt-0 mt-1 pb-2" v-else>
            <div class="card">
                <div class="card-body">
                    <button type="button" class="btn btn-primary btn-block btn-lg" :disabled="submitting"
                        @click="submitApplication">
                        <span v-show="submitting" class="spinner-border spinner-border-sm"></span>
                        <span>അപേക്ഷ സമർപ്പിക്കുക</span>
                    </button>
                </div>
            </div>
        </div>
    </template>

    <alert-model
        v-if="program.id && program.include_relief_fields === false"
        :type="alert_type"
        :message="alert_message"
        ref="alert_model"
    ></alert-model>
</template>

<script>
import ReliefFamilyForm from "./ReliefFamilyForm.vue";
import UserService from "@/services/user.service";
import AlertModel from "../layouts/AlertModel.vue";

export default {
    name: "SnehaSparshamApplication",
    components: {
        ReliefFamilyForm,
        AlertModel,
    },
    data() {
        return {
            loading: true,
            submitting: false,
            program: {},
            extraData: {},
            alert_type: "",
            alert_message: "",
            yesNoOptions: [
                { value: "Yes", label: "അതെ" },
                { value: "No", label: "ഇല്ല" },
            ],
        };
    },
    computed: {
        formFields() {
            return Array.isArray(this.program.form_fields) ? this.program.form_fields : [];
        },
    },
    mounted() {
        this.$root.updateParent("സ്നേഹ സ്പർശം അപേക്ഷ");
        UserService.authPostRequest("get-sneha-sparsham-program", {
            program_id: this.$route.params.program_id,
            user_level: parseInt(this.$route.params.sub_level, 10),
            user_level_id: parseInt(this.$route.params.id, 10),
        }).then((res) => {
            this.loading = false;
            if (res.data.status === "success") {
                this.program = res.data.data.program || {};
                this.initExtraData();
            }
        }).catch(() => {
            this.loading = false;
        });
    },
    methods: {
        setExtraField(key, value) {
            if (this.$set) {
                this.$set(this.extraData, key, value);
            } else {
                this.extraData[key] = value;
            }
        },
        initExtraData() {
            this.formFields.forEach((field) => {
                if (field.type === "checkbox") {
                    const current = this.extraData[field.key];
                    this.setExtraField(
                        field.key,
                        Array.isArray(current) ? [...current] : []
                    );
                } else if (this.extraData[field.key] === undefined) {
                    this.setExtraField(field.key, "");
                }
                if ((field.extra_field_options || []).length && this.extraData[field.key + "__extra"] === undefined) {
                    this.setExtraField(field.key + "__extra", "");
                }
            });
        },
        isCheckboxChecked(fieldKey, opt) {
            const arr = this.extraData[fieldKey];
            return Array.isArray(arr) && arr.indexOf(opt) !== -1;
        },
        toggleCheckbox(fieldKey, opt, event) {
            const arr = Array.isArray(this.extraData[fieldKey])
                ? [...this.extraData[fieldKey]]
                : [];
            const idx = arr.indexOf(opt);
            if (event.target.checked) {
                if (idx === -1) {
                    arr.push(opt);
                }
            } else if (idx !== -1) {
                arr.splice(idx, 1);
            }
            this.setExtraField(fieldKey, arr);
        },
        isFieldAnswered(field) {
            const value = this.extraData[field.key];
            if (field.type === "checkbox") {
                return Array.isArray(value) && value.length > 0;
            }
            return value !== null && value !== undefined && value !== "";
        },
        // Fields sharing the same non-empty required_group form an "either/or" requirement.
        // Within a group, fields sharing the same required_set bundle into one all-or-nothing
        // choice (e.g. 4 shop-detail questions that must ALL be filled together); a field with
        // no required_set is its own single-field choice. The group is satisfied once ANY one
        // of its sets is fully answered.
        //
        // required_set only makes sense paired with a required_group (its whole point is
        // bundling fields WITHIN a group) — an admin who fills in Required Set but forgets
        // Required Group would otherwise get silently NO validation at all, which is worse than
        // a possibly-imperfect grouping. Fall back to using the set name as the group name too,
        // so at minimum something is enforced.
        effectiveGroupKey(field) {
            return field.required_group || field.required_set || "";
        },
        fieldsInGroup(groupKey) {
            return this.formFields.filter((f) => this.effectiveGroupKey(f) === groupKey);
        },
        setsInGroup(groupKey) {
            const bySet = {};
            const order = [];
            this.fieldsInGroup(groupKey).forEach((f) => {
                const setKey = f.required_set || "__field__" + f.key;
                if (!bySet[setKey]) {
                    bySet[setKey] = [];
                    order.push(setKey);
                }
                bySet[setKey].push(f);
            });
            return order.map((setKey) => bySet[setKey]);
        },
        orderRangeLabel(fieldsList) {
            const idxs = fieldsList.map((f) => this.formFields.indexOf(f) + 1).sort((a, b) => a - b);
            if (!idxs.length) return "";
            const contiguous = idxs.every((v, i) => i === 0 || v === idxs[i - 1] + 1);
            return contiguous && idxs.length > 1 ? idxs[0] + "-" + idxs[idxs.length - 1] : idxs.join(", ");
        },
        groupRequirementMessage(groupKey) {
            const parts = this.setsInGroup(groupKey).map((setFields) => "(" + this.orderRangeLabel(setFields) + ")");
            return parts.join(" അല്ലെങ്കിൽ ") + " ഇവയിൽ ഏതെങ്കിലും ഒരു സെറ്റ് പൂർണമായി ഫിൽ ചെയ്യുക!";
        },
        validateExtraFields() {
            const checkedGroups = [];
            for (const field of this.formFields) {
                const groupKey = this.effectiveGroupKey(field);
                if (groupKey) {
                    if (checkedGroups.indexOf(groupKey) !== -1) continue;
                    checkedGroups.push(groupKey);
                    const anySetComplete = this.setsInGroup(groupKey).some((setFields) =>
                        setFields.every((f) => this.isFieldAnswered(f))
                    );
                    if (!anySetComplete) {
                        this.showWarning(this.groupRequirementMessage(groupKey));
                        return false;
                    }
                    continue;
                }
                if (!field.required) continue;
                if (!this.isFieldAnswered(field)) {
                    this.showWarning((field.label_ml || field.key) + " ഫിൽ ചെയ്യുക!");
                    return false;
                }
            }
            return true;
        },
        openAlert(type, message) {
            const relief = this.$refs.reliefForm;
            if (relief && this.program.include_relief_fields !== false) {
                relief.alert_type = type;
                relief.alert_message = message;
                this.$nextTick(() => {
                    if (relief.$refs.alert_model) {
                        relief.$refs.alert_model.openModel();
                    }
                });
                return;
            }
            this.alert_type = type;
            this.alert_message = message;
            this.$nextTick(() => {
                if (this.$refs.alert_model) {
                    this.$refs.alert_model.openModel();
                }
            });
        },
        showWarning(message) {
            this.openAlert("Warning", message || "ക്ഷമിക്കണം. വീണ്ടും ശ്രമിക്കുക.");
        },
        submitApplication() {
            if (!this.validateExtraFields()) return;
            if (this.program.include_relief_fields !== false && this.$refs.reliefForm) {
                this.$refs.reliefForm.triggerSubmit();
            } else {
                this.saveApplication({});
            }
        },
        onReliefValidated(reliefData) {
            this.saveApplication(reliefData);
        },
        saveApplication(reliefData) {
            this.submitting = true;
            const payload = { ...reliefData };
            payload.program_id = this.program.id;
            payload.extra_data = { ...this.extraData };
            this.formFields.forEach((field) => {
                if (field.type === "checkbox" && !Array.isArray(payload.extra_data[field.key])) {
                    payload.extra_data[field.key] = payload.extra_data[field.key] || [];
                }
            });
            if (this.program.include_relief_fields === false) {
                payload.unit_id = parseInt(this.$route.params.id, 10);
                payload.user_level = parseInt(this.$route.params.sub_level, 10);
            }
            // Always send the org context so the backend can honour per-unit programme access.
            payload.user_level = parseInt(this.$route.params.sub_level, 10);
            payload.user_level_id = parseInt(this.$route.params.id, 10);
            UserService.addAdmin("store-sneha-sparsham-application", payload).then((response) => {
                this.submitting = false;
                if (response.data.status === "success") {
                    this.openAlert("Success", response.data.message || "അപേക്ഷ സമർപ്പിച്ചു.");
                    setTimeout(() => this.$router.go(-1), 2000);
                } else if (response.data.status === "warning") {
                    this.showWarning(response.data.message);
                } else {
                    this.showWarning(response.data.message || "സമർപ്പിക്കാൻ സാധിച്ചില്ല.");
                }
            }).catch((error) => {
                this.submitting = false;
                const msg =
                    (error.response && error.response.data && error.response.data.message) ||
                    error.message ||
                    "സമർപ്പിക്കാൻ സാധിച്ചില്ല. വീണ്ടും ശ്രമിക്കുക.";
                this.showWarning(msg);
            });
        },
    },
};
</script>

<style scoped>
select.form-control.custom-select.sneha-select-placeholder {
    color: #6c757d !important;
    -webkit-text-fill-color: #6c757d !important;
}
select.form-control.custom-select:not(.sneha-select-placeholder) {
    color: #212529 !important;
    -webkit-text-fill-color: #212529 !important;
}

.sneha-option-group {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 6px;
}

.sneha-option-group--stack {
    flex-direction: column;
}

.sneha-option-tile {
    display: flex;
    align-items: center;
    min-height: 44px;
    padding: 10px 14px;
    border: 1px solid #ced4da;
    border-radius: 10px;
    background: #fff;
    cursor: pointer;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    flex: 1 1 calc(50% - 10px);
}

.sneha-option-group--stack .sneha-option-tile {
    flex: 1 1 auto;
}

.sneha-option-tile.selected {
    border-color: #0d6efd;
    background: #eef4ff;
}

.sneha-option-input {
    position: absolute;
    opacity: 0;
    width: 1px;
    height: 1px;
    pointer-events: none;
}

.sneha-option-label {
    width: 100%;
    color: #212529;
    font-size: 15px;
    line-height: 1.3;
    pointer-events: none;
}

.sneha-option-tile--check.selected .sneha-option-label::before {
    content: "✓ ";
    color: #0d6efd;
    font-weight: 700;
}
</style>
